// extracted by mini-css-extract-plugin
module.exports = {"flex":"Tab_flex__1o4ge","img":"Tab_img__2fAOx","active":"Tab_active__2A2T-","paragraph":"Tab_paragraph__1MAfP"};